import React, { useState } from "react";
import Api from "../../app/api";

export default function Forgot({ email, setEmail, navigate, setStep }) {
    const [loading, setLoading] = useState(false);

    const handleForgot = (e) => {
        e.preventDefault();
        setLoading(true);

        if (email === "") {
            alert("กรุณากรอกอีเมล");
            return;
        }

        const formData = new FormData();
        formData.append("email", email);

        // Send Email and Create Token
        Api.post("/auth/forgot", formData)
            .then((response) => {
                const data = response.data;

                if (data.message === "OK") {
                    alert("ระบบได้ส่งจดหมายเปลี่ยนรหัสผ่านไปยังอีเมลของท่านแล้ว");
                } else if (data?.message === "email__does_not_exist_in_database") {
                    alert(`ไม่มีอีเมล ${email} ในฐานข้อมูล`);
                }

                setLoading(false);
            })
            .catch((error) => {
                const data = error?.response?.data;

                if (data?.message === "email__does_not_exist_in_database") {
                    alert(`ไม่มีอีเมล ${email} ในฐานข้อมูล`);
                } else {
                    alert(`เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง`);
                }

                setLoading(false);
            });
    };

    return (
        <>
            <div className="h3">ลืมรหัสผ่าน</div>
            <div>R-DNAM ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว</div>

            <form onSubmit={handleForgot} className="mt-5">
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12 }}>
                        Email address
                    </label>
                    <input
                        type="email"
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={email}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <div className="d-flex justify-content-between flex-wrap align-items-center">
                    <div className="mt-4">
                        <span className="a-style" onClick={() => navigate("/login")}>
                            เข้าสู่ระบบ
                        </span>
                        <span className="a-style mx-4" onClick={() => navigate("/register")}>
                            สมัครสมาชิก
                        </span>
                    </div>
                    <div className="mt-4">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            ส่งรหัสยืนยัน
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}
